import type { TabsConfig } from '#types/config/components/vf/tabs'

export default {
  brandClasses: {
    primary: {
      triggerContainer: 'mb-0.5 b-b b-grey-70 min-w-full i-flex',
      trigger: 'text-sm py-1 b-b-4 b-transparent ws-nowrap -mb-0.5',
      triggerActive: '!b-brand-2'
    }
  }
} as Partial<TabsConfig>
